module.exports = __webpack_public_path__ + "static/media/visa.afe1ddc9.svg";